// TODO: Implement error reporting system for web (crashlytics only works for iOS / Android)
const recordError = (error, isFatal = false) => {};

export default recordError;
